import { IEntity } from '@pf/shared-common';
import {
    ResourceAuth,
    WarehouseSearchRequestParams,
    WarehouseSettingsFragment,
    WarehouseViewModelCreateBody,
    WarehouseViewModelRead,
    ZoneLocationViewModel,
} from '@control-tower/platform-wms';
import {
    ICustomFieldDto,
    ILocationFragmentDto,
} from '@pf/shared/util-platform';
import { ZoneDto } from './zone.dto';

export type WarehouseRead = WarehouseViewModelRead & IEntity;
export type WarehouseCreate = WarehouseViewModelCreateBody;
export type WarehouseSearchParams = WarehouseSearchRequestParams;
export type WarehouseStructure = Array<ZoneLocationViewModel>;

export class WarehouseDto implements IEntity {
    constructor(data: Partial<WarehouseDto>) {
        Object.assign(this, data);
    }
    id!: string;
    isDeleted?: boolean;
    createdDate?: string;
    modifiedDate?: string;
    name!: string;
    code?: string;
    description?: string;
    locationId?: string;
    location?: ILocationFragmentDto | null;
    customFields?: ICustomFieldDto[] | null;
    zones?: ZoneDto[];
    settings?: WarehouseSettingsFragment | null;
    resourceAuth?: ResourceAuth;
}
